import { render, staticRenderFns } from "./UnsubscribeFragmentCard.vue?vue&type=template&id=12df8744&scoped=true&"
import script from "./UnsubscribeFragmentCard.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeFragmentCard.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscribeFragmentCard.vue?vue&type=style&index=0&id=12df8744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df8744",
  null
  
)

export default component.exports